export const DocumentRetrievalClientFailureStage = {
    CATALOG_SEARCH: "catalog_search",
    RESOLVE_ENDPOINT: "resolve_endpoint",
    DUPLICATE_CHECK: "duplicate_check",
    DUPLICATE_REFRESH: "duplicate_refresh",
    FHIR_START: "fhir_start",
    FHIR_AUTH_REDIRECT: "fhir_auth_redirect",
    FHIR_OAUTH_CALLBACK: "fhir_oauth_callback",
};
export function logDocumentRetrievalClientError(logLevel, message, attributes) {
    const prefixedMessage = `[Document Retrieval] ${message}`;
    if (logLevel === "error") {
        console.error(prefixedMessage, attributes);
    }
    else {
        console.warn(prefixedMessage, attributes);
    }
}
